import { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import "./ConfigurationProductDisplayCatDetails.css";
import ProductCard from '../../../component/ConfigurationsPage/ProductCard.jsx';
import CategoryProductPopup from './CategoryProductPopup.jsx';
import ClockIcon from './ClockIcon.jsx'; // Import the ClockIcon component

const ConfigurationProductDisplayCatDetails = ({ 
  selectedCategory, 
  products, 
  allCatWithProducts, 
  fetchLatestDataAndMap, 
  onClockClick, // Add this prop
  itemAvailability // Add this prop
}) => {
  const ebrizaLinkedId = localStorage.getItem('ebrizaLinkedId');
  const catProducts = products.filter((ele) => ele['CategoryId'] == selectedCategory['CategoryId']);
  const [popupOpen, setPopupOpen] = useState(false);

  const handleOpenPopup = () => {
    if (!ebrizaLinkedId) {
      setPopupOpen(true);
    }
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const handleSave = (selectedCategories, selectedProducts) => {
    // Handle save action
    console.log('Selected Categories:', selectedCategories);
    console.log('Selected Products:', selectedProducts);
  };

  // Helper function to check if product has availability schedule
  const hasProductSchedule = (productId) => {
    return itemAvailability[productId]?.length > 0;
  };

  return (
    <div className="details-view">
      <div className="cards">
        {catProducts.map((product, index) => (
          <div
            key={index}
            className="category-card"
            style={{ cursor: 'pointer', position: 'relative' }} // Add position relative
          >
            {/* Clock Icon for product */}
            <ClockIcon
              onClick={() => onClockClick(product.ProductId, 'product', product.name)}
              hasSchedule={hasProductSchedule(product.ProductId)}
              tooltip="Set product availability schedule"
              size="small"
              sx={{
                    position: 'absolute',
                    top: '8px',
                    right: '35px',
                    color: 'black',
                    zIndex: 2,
                    borderRadius: '7px',
                    backgroundColor: '#fff',
                    padding: '4px 1px'
                  }}
            />

            <ProductCard
              product={product}
              name1={product.name}
              imgUrl={product.imageUrl}
              price={product.priceVAT}
              fetchLatestDataAndMap={fetchLatestDataAndMap}
            />
          </div>
        ))}
        
        <div
          onClick={handleOpenPopup}
          style={ebrizaLinkedId ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}
          className="category-card7"
        >
          <img className="icons22" alt="" src="/icons1.svg" />
          <div className="add-category7">Add Product</div>
        </div>
      </div>
      
      <CategoryProductPopup
        open={popupOpen}
        onClose={handleClosePopup}
        categories={allCatWithProducts}
        activeCategory={selectedCategory}
        onSave={handleSave}
        fetchLatestDataAndMap={fetchLatestDataAndMap}
      />
    </div>
  );
};

export default ConfigurationProductDisplayCatDetails;